import { render, staticRenderFns } from "./TableInstituciones.vue?vue&type=template&id=62c30a4e&scoped=true"
import script from "./TableInstituciones.vue?vue&type=script&lang=js"
export * from "./TableInstituciones.vue?vue&type=script&lang=js"
import style0 from "./TableInstituciones.vue?vue&type=style&index=0&id=62c30a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c30a4e",
  null
  
)

export default component.exports